export const environment = {
  production: true,
  apiUrl: 'https://garantiportalapi-Prod.azurewebsites.net/api/',
  brandName: 'Garanti Portal',
  creditorBrandName: 'Borgenärsportalen',
};
